import styled from 'styled-components';

export const StyledEntryStatus = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text-main);
  width: 350px;
  padding: 15px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px;
  background-color: #ffffff;

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 10px;
  }

  .component-body {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }

  .component-body .chart {
    margin-left: 10px;
    width: 120px;
    height: 120px;
  }

  .item-list {
    display: flex;
    flex-direction: column;
    flex: 1 0;
    overflow-y: auto;
    gap: 10px;
  }

  .item {
    display: flex;
    justify-content: space-between;
  }

  .item .label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 400;
    color: #2f2f35;
  }

  .item .label-icon {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .item .value {
    display: flex;
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
  }
`;
